<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_military_fleets')
}

const isOnCommandSection = computed(() => {
  return route.path.startsWith('/command/fleets')
})

const goToCommand = () => {
  router.push('/command/fleets')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/military.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.military.fleets.intro') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.military.fleets.managing') }}
      </p>
      <p class="pb-3">
        <i18n-t keypath="tutorial.military.fleets.fleetTypes" tag="span">
          <template #coreFleet><span class="text-blue-500">{{ t('tutorial.military.fleets.coreFleet') }}</span></template>
          <template #reinforcements><span class="text-yellow-500">{{ t('tutorial.military.fleets.reinforcements') }}</span></template>
        </i18n-t>
      </p>
      <p class="pb-3">
        {{ t('tutorial.military.fleets.activeMissions') }}
      </p>
      <p class="pb-3">
        {{ t('tutorial.military.fleets.comeBack') }}
      </p>

    </template>

    <template #alerts>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnCommandSection" @click="goToCommand" class="mr-2">
        {{ t('tutorial.military.fleets.goToFleets') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('common.actions.continue') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>